import {
  formatDate,
  formatTime,
  formatTimeWithTimeZone,
  formatTimeZone,
  isSameDay,
  isToday,
  isTomorrow,
  isYesterday,
} from "@clipboard-health/date-time";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect, useState } from "react";
import { getComputedArrivalForWorker } from "@src/appV2/Shifts/utils/getComputedArrival";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'shift' implicitly has an 'any' type.
function ShiftDescription({ shift, isCancel }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [state, setState] = useState<any>({});
  useEffect(() => {
    const timeZone = shift.facility?.tmz ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
    const options = { timeZone };
    const startDate = new Date(shift.start);
    const endDate = new Date(shift.end);
    const startAndEndInDifferentTimezone =
      formatTimeZone(startDate, options) !== formatTimeZone(endDate, options);
    const calendar = buildCalendarLabel(startDate, options);
    const startEndSameDay = isSameDay(startDate, endDate, options);
    const rangeText = `${formatTimeWithTimeZone(startDate, options)} until ${
      startAndEndInDifferentTimezone
        ? `${formatTimeWithTimeZone(endDate, options)},`
        : formatTime(endDate, options)
    }`;
    const computedArrival = getComputedArrivalForWorker({
      computedArrivals: shift.computedArrivals,
      agentId: shift.agentId,
      bookedAt: shift.bookedAt,
      start: shift.start,
    });

    setState({
      calendar,
      rangeText,
      duration: `${shift.time?.toFixed(2)} hrs`,
      nextDay: startEndSameDay ? "" : "next day",
      isHoliday: shift.isHolidayShift,
      holidayName: shift.holidayName,
      startAndEndInDifferentTimezone,
      computedArrival,
    });
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shift]);

  return (
    <div data-testid="shift-item-admin-shift-description">
      {state.calendar}
      {isCancel && shift.isBillable && "(Late Cancel: $" + shift.charge * shift.time + " Fee)"}
      <i>
        {" "}
        ({state.duration}, {state.rangeText}
        {state.nextDay && ` ${state.nextDay}`}
        {state.startAndEndInDifferentTimezone && " with a clock change for Daylight Saving Time"})
      </i>
      <br />
      {!isCancel && shift.extendBookabilityTo && shift.extendBookabilityTo > shift.start && (
        <p>
          Bookable until{" "}
          {formatTime(shift.extendBookabilityTo, {
            timeZone: shift.facility?.tmz,
          })}
        </p>
      )}
      {state.computedArrival && (
        <p>
          <strong>
            Target arrival time:{" "}
            {formatTime(state.computedArrival.targetArrivalTime, {
              timeZone: shift.facility?.tmz,
            })}
          </strong>
        </p>
      )}
      {state.isHoliday && (
        <h4>It is {state.holidayName || "a holiday"}. Holiday charges will apply.</h4>
      )}
    </div>
  );
}

function buildCalendarLabel(start: Date, options: { timeZone: string }): string {
  const time = formatTime(start, options);
  if (isToday(start, options)) {
    return `Today at ${time}`;
  }
  if (isTomorrow(start, options)) {
    return `Tomorrow at ${time}`;
  }
  if (isYesterday(start, options)) {
    return `Yesterday at ${time}`;
  }
  return formatDate(start, options);
}

export { ShiftDescription };
